var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_241_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9198 0H1.07982C0.866649 2.08328e-05 0.658274 0.0633042 0.48109 0.181836C0.303906 0.300367 0.165883 0.468814 0.0845006 0.665844C0.00311857 0.862875 -0.0179615 1.07962 0.0239302 1.28864C0.0658218 1.49766 0.168801 1.68955 0.319825 1.84L5.50082 7.02C5.90031 7.41851 6.44155 7.64231 7.00583 7.64231C7.5701 7.64231 8.11134 7.41851 8.51083 7.02L10.4808 5.05L13.6908 1.84C13.8401 1.68796 13.9411 1.49525 13.9813 1.28601C14.0215 1.07678 13.999 0.860345 13.9166 0.663844C13.8343 0.467343 13.6958 0.299523 13.5185 0.181428C13.3411 0.0633333 13.1329 0.000219241 12.9198 0Z",
    fill: "#39342F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_241_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/CaretDown.35016a544ac955275317eac9edfca76e.svg";
export { ForwardRef as ReactComponent };